import { render, staticRenderFns } from "./TrialEndedModal.vue?vue&type=template&id=79ddf9fb&scoped=true"
import script from "./TrialEndedModal.vue?vue&type=script&lang=js"
export * from "./TrialEndedModal.vue?vue&type=script&lang=js"
import style0 from "./TrialEndedModal.vue?vue&type=style&index=0&id=79ddf9fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ddf9fb",
  null
  
)

export default component.exports